import { MessagePlugin } from 'tdesign-vue-next'

import { getEvaluateCount, getEvaluateTree, getQueryComments, putEvaluateSubmit } from '@/api/evaluate'

export default () => {
  /**
   * 获取指标tree
   * @param params
   * @returns {Promise<void>}
   */
  const getEvaluateTreeRequest = async (projectId) => {
    try {
      const res = await getEvaluateTree(projectId)
      const { data } = res.data
      return data || 0
    } catch (error) {
      error.message && MessagePlugin.error(error.message || '操作失败，请重试')
    }
  }
  /**
   * 获取指标被评价次数
   * @param params
   * @returns {Promise<void>}
   */
  const getEvaluateCountRequest = async (params) => {
    try {
      const res = await getEvaluateCount(params)
      const { data } = res.data
      return data || 0
    } catch (error) {
      error.message && MessagePlugin.error(error.message || '操作失败，请重试')
    }
  }
  /**
   * 提交验收
   * @param params
   * @returns {Promise<void>}
   */
  const putEvaluateSubmitRequest = async (params) => {
    try {
      const res = await putEvaluateSubmit(params)
      const { data } = res.data
      return data || 0
    } catch (error) {
      error.message && MessagePlugin.error(error.message || '操作失败，请重试')
    }
  }
  /**
   * 获取评语列表
   * @param params
   * @returns {Promise<void>}
   */
  const getQueryCommentsRequest = async (targetId) => {
    try {
      const res = await getQueryComments(targetId)
      const { data } = res.data
      return data || []
    } catch (error) {
      error.message && MessagePlugin.error(error.message || '操作失败，请重试')
    }
  }

  return {
    getEvaluateTreeRequest, // 获取指标tree
    getQueryCommentsRequest, // 获取评语列表
    getEvaluateCountRequest, // 获取指标被评价次数
    putEvaluateSubmitRequest, // 提交验收
  }
}
